module.exports = __webpack_public_path__ + "static/media/julesondesign-IG.2bf0fd83.PNG";